module.exports = __webpack_public_path__ + "img/16.60682b4d.jpg";